import React, { useEffect, useState } from 'react';
import { FaSave, FaCalendarAlt } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useToasts } from 'react-toast-notifications';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';

import * as localdb from '../../../localdb';
import { API } from 'aws-amplify';
import { Formik } from "formik";
import * as yup from "yup";

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import './AssetAdd.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';

const AssetAdd = (props) => {
    const { t, tCatalog } = useI18n();
    const { addToast } = useToasts();
    const [isAssetEdit, setAssetEdit] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [asset, setAsset] = useState({site_address: '',
                                        site_ref: '',
                                        district: '',
                                        charge_code: '',
                                        type: '',
                                        elv_lv: '',
                                        controller: '',
                                        signal_head: '',
                                        halogen_led: '',
                                        hp_site: false,
                                        latitude: '',
                                        longitude: '',
                                        date_created: new Date().toISOString(),
                                        asset_active: true,
                                        push_button: '',
                                        operating_mode: '',
                                        tmrpn: '',
                                        power_consumption: '',
                                        billed_consumption:'',
                                        installation_date:'',
                                        upgrade_date:'',
                                        supply_source:'',
                                        supply_gps_lat:'',
                                        supply_gps_long:'',

                                        make:'',
                                        // supply_source:'',
                                        sign_display:'',
                                        installed_by:'',
                                        // installation_date:'',

                                        school_name:'',
                                        school_number:'',
                                        school_email:'',

                                        controller_link: '',
                                        camera_link: '',

                                        school_det: [],
                                    });
	const [upgrade_date, setUpgrade_date] = useState('');
	const [installation_date, setInstallation_date] = useState('');
	const [districtList, setDistrictList] = useState([]);
	const [chargeCodeList, setChargeCodeList] = useState([]);
	const [assetType, setAssetType] = useState('');

    

    const params = { 
        headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,        
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        },
    }

    // Load asset 
    useEffect(()=>{
        if (props.match.params.id){
            setAssetEdit(true);
            API.get('assets_no_log','/' + props.match.params.id, params)
            .then(res => { 

                res.site_address = res.site_address || ''
                res.controller = res.controller ||  ''
                res.signal_head = res.signal_head || ''
                res.tmrpn = res.tmrpn || ''
                res.power_consumption = res.power_consumption || ''
                res.billed_consumption = res.billed_consumption || ''
                res.installation_date = (res.installation_date !== undefined) ? setInstallation_date(new Date(res.installation_date)) : ''
                res.upgrade_date = (res.upgrade_date !== undefined) ? setUpgrade_date(new Date(res.upgrade_date)) : ''
                res.supply_source = res.supply_source || ''
                res.supply_gps_lat = res.supply_gps_lat || ''
                res.supply_gps_long = res.supply_gps_long || ''
                if (res.type) setAssetType(res.type);

                res.make = res.make || ''
                res.sign_display = res.sign_display || ''
                res.installed_by = res.installed_by || ''

                res.school_name = res.school_name || ''
                res.school_number = res.school_number || ''
                res.school_email = res.school_email || ''

                res.controller_link = res.controller_link || ''
                res.camera_link = res.camera_link || ''

                if (res.school_det === undefined) {
                    res.school_det = [];
                    for (let i = 0; i < 4; i++) {
                        res.school_det.push({school_times: '', school_switch_on: '', school_switch_off: ''})                           
                    }
                } else {
                    for (let i = 0; i < 4; i++) {                     
                        res.school_det[i].school_times = res.school_det[i].school_times || '';
                        res.school_det[i].school_switch_on = res.school_det[i].school_switch_on || '';
                        res.school_det[i].school_switch_off = res.school_det[i].school_switch_off || '';                       
                    }
                }
                
                // console.log(res)
                setAsset(res);
                setAssetEdit(false);
            });
        }else{
            asset.school_det = [];
            for (let i = 0; i < 4; i++) {
                asset.school_det.push({school_times:'', school_switch_on: '', school_switch_off: ''})                           
            }
        }
    }, []);
    
    // Load district
	useEffect(()=>{
		const fetchDistrict = async () => {
			
			const districts = await API.get('settings','/DISTRICTS', params)
			// districts.values.sort((a, b) => (a > b) ? 1 : -1)

			const unique = [...new Set((districts.values || []).filter(Boolean))];
			const list = unique.map((name) => (
				<option key={name} value={name}>{name}</option>
			));

			setDistrictList(list);
		}
		fetchDistrict();	 
    }, []);

    // Load charge code
	useEffect(()=>{
		const fetchChargeCode = async () => {
			
			const codes = await API.get('settings','/CHARGE_CODE', params)
			codes.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < codes.values.length; i++) {
				list.push(<option key={codes.values[i]} value={codes.values[i]}>{codes.values[i]}</option>)
			}

			setChargeCodeList(list);
		}
		fetchChargeCode();	 
    }, []);

    const handleSubmit = (data) => {
        
        //Edit task
        if (asset){
        data.assetId = asset.assetId     
       }
       if (data.hp_site==="true")
        data.hp_site = true;    
       else
        data.hp_site = false;

        if (installation_date)
            data.installation_date = installation_date;

       //Clean up data before Post
       data = Object.entries(data).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})

      
    //    console.log(data)

       API.post('assets', '/', {      
           body: data,
           headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
       })
       .then(response => {
        //    console.log(response)
           addToast(t('toast.assetSaved'), { appearance: 'success' });
           props.history.push('/asset_det/'+ response );           
       }).catch(error => {
           console.log(error)
           addToast(t('toast.errorSavingAsset'), { appearance: 'error' });
       });          
       setBtnDisabled(true);

    };

    const isWestmeathEnv = process.env.REACT_APP_GLOB_APP_ENV === 'westmeath';
    const isMeathEnv = process.env.REACT_APP_GLOB_APP_ENV === 'meathcc';
    const westmeathOnlyAssetTypes = [
        "Microsense Pelican Crossing",
        "Pelican Crossing, Swarco",
        "Pelican Crossing, ITS",
        "Puffin Crossing",
        "PSC",
        "PSC PD 208",
        "MOVA Controller",
        "Swarco ITC c/w inductive loops (connected via SIM to Remote Monitoring System)",
        "Microsense Pedistal",
        "Driver Feedback Sign",
        "Driver Feedback Sign (Sierzega) / DFS (Sierzega)",
        "Electronic Speed Warning Sign",
        "Programmable Flashing Light School Warning System",
        "Programmable Flashing Light School Warning System (Solar)",
    ];
    const assetTypes = isWestmeathEnv
        ? [...localdb.ASSET_TYPE, ...westmeathOnlyAssetTypes]
        : localdb.ASSET_TYPE;
    const assetTypeList = Object.keys(assetTypes).map((item, i) => (
        <option key={"assetType"+i} value={assetTypes[item]}>{tCatalog(assetTypes[item])}</option>
    ));

    const schema = yup.object().shape({
        site_address: yup.string()
            .required(t('common.required')),
        site_ref: yup.string()
            .required(t('common.required')),
        district: yup.string()
            .required(t('common.required')),
        charge_code: yup.string()
            .required(t('common.required')),
        elv_lv: yup.string(),
        controller: yup.string(),
        signal_head: yup.string(),
        halogen_led: yup.string(),
        push_button: yup.string(),
        operating_mode: yup.string(),
        tmrpn: yup.string(),
        power_consumption: yup.string(),
        hp_site: yup.boolean(),
        latitude: yup.number()
            .typeError("This is not a valid number")
            .required(t('common.required')),
        longitude: yup.number()
            .typeError("This is not a valid number")
            .required(t('common.required')),

        billed_consumption: yup.string(),
        installation_date: yup.string()
            .nullable(true),
        upgrade_date: yup.string()
            .nullable(true),
        supply_source: yup.string(),
        supply_gps_lat: yup.number()
        .typeError("This is not a valid number"),
        supply_gps_long: yup.number()
        .typeError("This is not a valid number"),
        make: yup.string(),
        sign_display: yup.string(),
        installed_by: yup.string()
        .nullable(true),

        school_name: yup.string(),
        school_number: yup.string(),
        school_email: yup.string(),

        controller_link: yup.string(),
        camera_link: yup.string(),

        });


        return (   
            !isAssetEdit ? (  
            <Formik //enableReinitialize               
            initialValues={asset}
            validationSchema={schema}
            onSubmit={ (values, { setSubmitting }) => {
                setBtnDisabled(true);
                handleSubmit(values);
                setSubmitting(false);
            }}

            >
            {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (

        <div className="AssetAdd">
        <form onSubmit={handleSubmit}>
        <PageHeader
            title={asset.assetId ? t('pages.assetAdd.editTitle') : t('pages.assetAdd.newTitle')}
            breadcrumbs={[
                { label: t('nav.assets'), path: '/assets' },
                { label: asset.assetId ? t('common.edit') : t('pages.assetAdd.newTitle') },
            ]}
            backTo={asset.assetId ? `/asset_det/${asset.assetId}` : '/assets'}
            backLabel={asset.assetId ? t('pages.assetDetails.title') : t('nav.assets')}
            actions={
                <Button variant="success" type="submit" disabled={btnDisabled}>
                    {t('taskForm.save')} <FaSave />
                </Button>
            }
        />

        <div className="div-content">
            
        <Tabs defaultActiveKey="details" transition={false} id="tab_asset_det">
            <Tab eventKey="details" title={t('actions.details')}>
                <TabContent className="p-3" >
                <div className="row">
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="district" className={touched.district && errors.district ? "has-error" : null}>
                        <Form.Label>{t('common.district')}</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={values.district} 
                            onChange={handleChange}>
                                <option value=""></option>
                                {districtList}  
                        </Form.Control>   
                        {touched.district && errors.district ? <div className="error-message">{errors.district}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="site_ref" className={touched.site_ref && errors.site_ref ? "has-error" : null}>
                        <Form.Label>{t('fields.siteReference')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.site_ref} 
                            onChange={handleChange} 
                            type="text" />
                        {touched.site_ref && errors.site_ref ? <div className="error-message">{errors.site_ref}</div> : null} 
                    </Form.Group>
                    </div>

                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="charge_code" className={touched.charge_code && errors.charge_code ? "has-error" : null}>
                        <Form.Label>{t('fields.chargeCode')}</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={values.charge_code} 
                            onChange={handleChange}>
                                <option value=""></option>
                                {chargeCodeList}  
                        </Form.Control>  
                        {touched.charge_code && errors.charge_code ? <div className="error-message">{errors.charge_code}</div> : null}                
                    </Form.Group>
                    </div>

                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="site_address" className={touched.site_address && errors.site_address ? "has-error" : null}>
                        <Form.Label>{t('fields.siteLocation')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.site_address} 
                            onChange={handleChange} 
                            type="text" />
                        {touched.site_address && errors.site_address ? <div className="error-message">{errors.site_address}</div> : null} 
                    </Form.Group>
                    </div> 
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="type"  className={touched.type && errors.type ? "has-error" : null}>
                        <Form.Label>{t('common.type')}</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={values.type} 
                            onChange={e => {
                                    setAssetType(e.target.value)
                                    setFieldValue('type', e.target.value, false);                                 
                                    }}>
                                <option value=""></option>
                                {assetTypeList}  
                        </Form.Control>   
                        {touched.type && errors.type ? <div className="error-message">{errors.type}</div> : null}               
                    </Form.Group>
                    </div>  
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="hp_site"  className={touched.hp_site && errors.hp_site ? "has-error" : null}>
                        <Form.Label>{t('fields.prioritySite')}</Form.Label>
                        <Form.Control 
                            as="select" 
                            value={values.hp_site} 
                            onChange={handleChange}>                           
                                <option value={true}>{t('assets.high')}</option>
                                <option value={false}>{t('assets.low')}</option>
                        </Form.Control>   
                        {touched.hp_site && errors.hp_site ? <div className="error-message">{errors.hp_site}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-12"><hr/></div>
                    <div className="col-md-12"><h4 className="text-dark">{t('fields.gpsCoordinates')}</h4></div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="latitude"  className={touched.latitude && errors.latitude ? "has-error" : null}>
                        <Form.Label>{t('fields.latitude')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.latitude} 
                            onChange={handleChange} 
                            type="number" 
                            step="0.00000001" />
                        {touched.latitude && errors.latitude ? <div className="error-message">{errors.latitude}</div> : null} 
                    </Form.Group>
                    </div>   
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="longitude"  className={touched.longitude && errors.longitude ? "has-error" : null}>
                        <Form.Label>{t('fields.longitude')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.longitude} 
                            onChange={handleChange} 
                            type="number" 
                            step="0.00000001" />
                        {touched.longitude && errors.longitude ? <div className="error-message">{errors.longitude}</div> : null} 
                    </Form.Group>
                    </div>
                    {isMeathEnv ? (
                    <>
                    <div className="col-md-12"><hr/></div>
                    <div className="col-md-12"><h4 className="text-dark">{t('fields.remoteAccess')}</h4></div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="controller_link" className={touched.controller_link && errors.controller_link ? "has-error" : null}>
                        <Form.Label>{t('fields.controllerLink')}</Form.Label>
                        <Form.Control
                            as="input"
                            value={values.controller_link}
                            onChange={handleChange}
                            type="text"
                            placeholder="e.g. 10.202.0.1 or http://10.202.0.1"
                        />
                        {touched.controller_link && errors.controller_link ? <div className="error-message">{errors.controller_link}</div> : null}
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="camera_link" className={touched.camera_link && errors.camera_link ? "has-error" : null}>
                        <Form.Label>{t('fields.cameraLink')}</Form.Label>
                        <Form.Control
                            as="input"
                            value={values.camera_link}
                            onChange={handleChange}
                            type="text"
                            placeholder="e.g. 10.202.0.2 or http://10.202.0.2"
                        />
                        {touched.camera_link && errors.camera_link ? <div className="error-message">{errors.camera_link}</div> : null}
                    </Form.Group>
                    </div>
                    </>
                    ) : null}
                </div>
                </TabContent>
            </Tab>
            <Tab eventKey="controller" title={t('common.equipment')}>
            <TabContent  className="p-3">    
            {(assetType !== 'School Warning Sign' && assetType !=='Periodic Speed Limit Sign' && assetType !== 'Sign - Other') ? (        
            <div className="row">
                <div className="col-md-4 p-0">
                    {/* controller */}
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="controller"  className={touched.controller && errors.controller ? "has-error" : null}>
                        <Form.Label>{t('fields.controller')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.controller} 
                            onChange={handleChange} 
                            type="text" />
                        {touched.controller && errors.controller ? <div className="error-message">{errors.controller}</div> : null} 
                    </Form.Group>
                    </div>    
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="signal_head"  className={touched.signal_head && errors.signal_head ? "has-error" : null}>
                        <Form.Label>{t('fields.signalHead')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.signal_head} 
                            onChange={handleChange} 
                            type="text" />
                        {touched.signal_head && errors.signal_head ? <div className="error-message">{errors.signal_head}</div> : null} 
                    </Form.Group>
                    </div> 
                    <div className="row px-3">
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="elv_lv"  className={touched.elv_lv && errors.elv_lv ? "has-error" : null}>
                            <Form.Label>{t('fields.elvLv')}</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={values.elv_lv} 
                                onChange={handleChange}>                           
                                    <option value=""></option>
                                    <option value="ELV">ELV</option>
                                    <option value="LV">LV</option>
                            </Form.Control>  
                            {touched.elv_lv && errors.elv_lv ? <div className="error-message">{errors.elv_lv}</div> : null}                
                        </Form.Group>
                        </div> 
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="halogen_led"  className={touched.halogen_led && errors.halogen_led ? "has-error" : null}>
                            <Form.Label>{t('fields.halogenLed')}</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={values.halogen_led} 
                                onChange={handleChange}>                           
                                    <option value=""></option>
                                    <option value="Halogen">Halogen</option>
                                    <option value="LED">LED</option>
                                    <option value="Halogen & LED">Halogen & LED</option>
                            </Form.Control>   
                            {touched.halogen_led && errors.halogen_led ? <div className="error-message">{errors.halogen_led}</div> : null}               
                        </Form.Group>
                        </div> 
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="push_button"  className={touched.push_button && errors.push_button ? "has-error" : null}>
                            <Form.Label>{t('fields.pushButton')}</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={values.push_button} 
                                onChange={handleChange}>                           
                                    <option value=""></option>
                                    <option value="AGD">AGD</option>
                                    <option value="Braums">Braums</option>
                                    <option value="Aldridge">Aldridge</option>                          
                                    <option value="Swarco">Swarco</option>
                                    <option value="Prisma">Prisma</option>
                                    <option value="Yellow">Yellow</option>
                                    <option value="None">None</option>
                                    <option value="N/A">N/A</option>
                            </Form.Control>   
                            {touched.push_button && errors.push_button ? <div className="error-message">{errors.push_button}</div> : null}               
                        </Form.Group>
                        </div>
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="operating_mode"  className={touched.operating_mode && errors.operating_mode ? "has-error" : null}>
                            <Form.Label>{t('fields.operatingMode')}</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={values.operating_mode} 
                                onChange={handleChange}>                           
                                    <option value=""></option>
                                    <option value="Fixed Time">Fixed Time</option>
                                    <option value="Vehicle Activated">Vehicle Activated</option>
                                    <option value="Mova">Mova</option>
                                    <option value="Spot">Spot</option>
                                    <option value="Scats">Scats</option>
                                    <option value="N/A">N/A</option>
                            </Form.Control>    
                            {touched.operating_mode && errors.operating_mode ? <div className="error-message">{errors.operating_mode}</div> : null}               
                        </Form.Group>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 p-0">
                    {/* power */}
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="tmrpn"  className={touched.tmrpn && errors.tmrpn ? "has-error" : null}>
                        <Form.Label>{t('fields.tmrpn')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.tmrpn} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.tmrpn && errors.tmrpn ? <div className="error-message">{errors.tmrpn}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="power_consumption"  className={touched.power_consumption && errors.power_consumption ? "has-error" : null}>
                        <Form.Label>{t('fields.powerConsumption')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.power_consumption} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.power_consumption && errors.power_consumption ? <div className="error-message">{errors.power_consumption}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="billed_consumption"  className={touched.billed_consumption && errors.billed_consumption ? "has-error" : null}>
                        <Form.Label>{t('fields.billedConsumption')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.billed_consumption} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.billed_consumption && errors.billed_consumption ? <div className="error-message">{errors.billed_consumption}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="row px-3">
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="installation_date"  className={touched.installation_date && errors.installation_date ? "has-error" : null}>
                            <Form.Label><FaCalendarAlt className="text-secondary" /> {t('fields.installationDate')}</Form.Label>
                            <DatePicker 
                                dateFormat="dd/MM/yyyy" 
                                selected={installation_date} 
                                onChange={e => {
                                    setInstallation_date(e)
                                    setFieldValue('installation_date', e, false);
                                    }}
                                className="form-control" />

                            {touched.installation_date && errors.installation_date ? <div className="error-message">{errors.installation_date}</div> : null}               
                        </Form.Group>
                        </div>
                        <div className="col-md-6 pb-2">
                        <Form.Group controlId="upgrade_date"  className={touched.upgrade_date && errors.upgrade_date ? "has-error" : null}>
                            <Form.Label><FaCalendarAlt className="text-secondary" /> {t('fields.upgradeDate')}</Form.Label>
                            <DatePicker 
                                dateFormat="dd/MM/yyyy" 
                                selected={upgrade_date} 
                                onChange={e => {
                                    setUpgrade_date(e);
                                    setFieldValue('upgrade_date', e, false);

                                }} 
                                className="form-control"
                                />
                            {touched.upgrade_date && errors.upgrade_date ? <div className="error-message">{errors.upgrade_date}</div> : null}               
                        </Form.Group>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 p-0">
                    {/* supply */}
                    <div className="col-md-12 pb-2">
                    <Form.Group controlId="supply_source"  className={touched.supply_source && errors.supply_source ? "has-error" : null}>
                        <Form.Label>{t('fields.supplySource')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.supply_source} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.supply_source && errors.supply_source ? <div className="error-message">{errors.supply_source}</div> : null}               
                    </Form.Group>
                    </div>

                    <div className="col-md-12 pb-3 bg-light border rounded">
                    <h4>{t('fields.supplyGps')}</h4>
                    <div className="col-md-12 p-0 pb-2">
                    <Form.Group controlId="supply_gps_lat"  className={touched.supply_gps_lat && errors.supply_gps_lat ? "has-error" : null}>
                        <Form.Label>{t('fields.latitude')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.supply_gps_lat} 
                            onChange={handleChange} 
                            type="number" 
                            step="0.00000001"
                            />   
                        {touched.supply_gps_lat && errors.supply_gps_lat ? <div className="error-message">{errors.supply_gps_lat}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-12 p-0 pb-2">
                    <Form.Group controlId="supply_gps_long"  className={touched.supply_gps_long && errors.supply_gps_long ? "has-error" : null}>
                        <Form.Label>{t('fields.longitude')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.supply_gps_long} 
                            onChange={handleChange} 
                            type="number" 
                            step="0.00000001" 
                            />   
                        {touched.supply_gps_long && errors.supply_gps_long ? <div className="error-message">{errors.supply_gps_long}</div> : null}               
                    </Form.Group>
                    </div>
                    </div>
                </div>
                    <div className="col-md-8 pb-2">
                        <Form.Group controlId="observations"  className={touched.observations && errors.observations ? "has-error" : null}>
                            <Form.Label>{t('fields.specialCondition')}</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows="3"  
                                value={values.observations} 
                                onChange={handleChange} 
                                /> 
                            {touched.observations && errors.observations ? <div className="error-message">{errors.observations}</div> : null}               
                        </Form.Group>
                    </div>
                </div>
                ):''}   
        {/* assetType = 'Sign - Other' OR assetType = 'School Warning Sign' */}

                {(assetType === 'Sign - Other' || assetType === 'Periodic Speed Limit Sign' || assetType === 'School Warning Sign') ? (  
                <div className="row">

                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="make"  className={touched.make && errors.make ? "has-error" : null}>
                        <Form.Label>{t('fields.makeModel')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.make} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.make && errors.make ? <div className="error-message">{errors.make}</div> : null}               
                    </Form.Group>
                    </div>

                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="supply_source"  className={touched.supply_source && errors.supply_source ? "has-error" : null}>
                        <Form.Label>{t('fields.supplySource')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.supply_source} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.supply_source && errors.supply_source ? <div className="error-message">{errors.supply_source}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="sign_display"  className={touched.sign_display && errors.sign_display ? "has-error" : null}>
                        <Form.Label>{t('fields.signDisplay')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.sign_display} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.sign_display && errors.sign_display ? <div className="error-message">{errors.sign_display}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="installed_by"  className={touched.installed_by && errors.installed_by ? "has-error" : null}>
                        <Form.Label>{t('fields.installedBy')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.installed_by} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.installed_by && errors.installed_by ? <div className="error-message">{errors.installed_by}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-2 pb-2">
                        <Form.Group controlId="installation_date"  className={touched.installation_date && errors.installation_date ? "has-error" : null}>
                            <Form.Label><FaCalendarAlt className="text-secondary" /> {t('fields.installationDate')}</Form.Label>
                            <DatePicker 
                                dateFormat="dd/MM/yyyy" 
                                selected={installation_date} 
                                onChange={e => {
                                    setInstallation_date(e)
                                    setFieldValue('installation_date', e, false);
                                    }}
                                className="form-control" />

                            {touched.installation_date && errors.installation_date ? <div className="error-message">{errors.installation_date}</div> : null}               
                        </Form.Group>
                    </div>
                    <div className="col-md-2 pb-2"></div>
                    <div className="col-md-4 pb-2">
                        <Form.Group controlId="observations"  className={touched.observations && errors.observations ? "has-error" : null}>
                            <Form.Label>{t('fields.additionalInfo')}</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows="3"  
                                value={values.observations} 
                                onChange={handleChange} 
                                /> 
                            {touched.observations && errors.observations ? <div className="error-message">{errors.observations}</div> : null}               
                        </Form.Group>
                    </div>
                </div>
                ):''}  

                {(assetType === 'School Warning Sign' || assetType === 'Periodic Speed Limit Sign') ? (  
                <div className="row">                 
                    <div className="col-md-12">
                        <hr/>
                        <h4>{t('fields.schoolDetails')}</h4>                      
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="school_name"  className={touched.school_name && errors.school_name ? "has-error" : null}>
                        <Form.Label>{t('fields.schoolName')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.school_name} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.school_name && errors.school_name ? <div className="error-message">{errors.school_name}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="school_number"  className={touched.school_number && errors.school_number ? "has-error" : null}>
                        <Form.Label>{t('fields.phoneNumber')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.school_number} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        {touched.school_number && errors.school_number ? <div className="error-message">{errors.school_number}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4 pb-2">
                    <Form.Group controlId="school_email"  className={touched.school_email && errors.school_email ? "has-error" : null}>
                        <Form.Label>{t('fields.email')}</Form.Label>
                        <Form.Control 
                            as="input" 
                            value={values.school_email} 
                            onChange={handleChange} 
                            type="email" 
                            />   
                        {touched.school_email && errors.school_email ? <div className="error-message">{errors.school_email}</div> : null}               
                    </Form.Group>
                    </div>
                    <div className="col-md-4"><Form.Label>{t('fields.schoolTimes')}</Form.Label></div>
                    <div className="col-md-4"><Form.Label>{t('fields.signSwitchOn')}</Form.Label></div>
                    <div className="col-md-4"><Form.Label>{t('fields.signSwitchOff')}</Form.Label></div>
                    {[...Array(4)].map((item, i) =>
                    <div className="col-md-12" key={"school_det_" + i}>
                    <div className="row">
                    <div className="col-md-4 p-2">                        
                        <Form.Control 
                            as="input" 
                            id={`school_det.${i}.school_times`}
                            value={values.school_det[i].school_times} 
                            onChange={handleChange}
                            type="text" 
                            />                          
                        </div>
                        <div className="col-md-4 p-2">
                        <Form.Control 
                            as="input" 
                            id={`school_det.${i}.school_switch_on`}
                            value={values.school_det[i].school_switch_on} 
                            onChange={handleChange} 
                            type="text" 
                            />   
                        </div>
                        <div className="col-md-4 p-2">
                        <Form.Control 
                            as="input"                             
                            id={`school_det.${i}.school_switch_off`}
                            value={values.school_det[i].school_switch_off} 
                            onChange={handleChange} 
                            type="text" 
                            />                         
                        </div>
                        </div>
                    </div>
                     )}   

                    
                </div>
                ):''} 
                </TabContent>    
            </Tab>
            </Tabs>
 
        </div>                  			
        </form>  
        </div>  
        )}
        </Formik>   ) : ''    
        );
    
}


export default AssetAdd;

